import { ReactElement } from 'react'
import { renderToString } from 'react-dom/server'

const reactElementToString = (element: ReactElement | string | undefined): string => {
    if (!element) {
        return ''
    }

    if (typeof element === 'string') {
        return element
    }

    return renderToString(element)
}

export default reactElementToString
